import '@/components/layout/styles/header.scss';

import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import useResponsive from '@/services/hocs/useResponsive';

import CustomLink from '@/components/CustomLink';
import Logo from '@/components/logo/Logo';
import ProfileDropdown from '@/components/profileDropdown/components/ProfileDropdown';

interface LayoutHeaderProps extends ComponentPropsWithoutRef<'header'> {
	className?: string;
	fullWidth?: boolean;
	previewMode?: boolean;
	showLogo?: boolean;
	showProfileDropdown?: boolean;
	children?: ReactNode;
}

const LayoutHeader = forwardRef<HTMLElement, LayoutHeaderProps>(
	(
		{
			className,
			fullWidth = false,
			previewMode,
			showLogo,
			showProfileDropdown,
			children,
			...rest
		},
		ref,
	) => {
		const { isMobile } = useResponsive();

		const content = (
			<div className="main-header-wrap">
				{showLogo && !isMobile && (
					<CustomLink to="/" className="logo-link">
						<Logo className="logo-image" />
					</CustomLink>
				)}
				{children}
				{showProfileDropdown && <ProfileDropdown previewMode={previewMode} />}
			</div>
		);

		return (
			<header
				className={classNames(
					'main-header',
					fullWidth && 'main-header--full-width',
					className,
				)}
				data-testid="main-header"
				ref={ref}
				{...rest}
			>
				{fullWidth ? content : <div className="container">{content}</div>}
			</header>
		);
	},
);

function mapStateToProps({ learningPathReducer }: any) {
	return {
		previewMode: learningPathReducer.previewMode,
	};
}

export default connect(mapStateToProps, {}, null, { forwardRef: true })(LayoutHeader);
